<div class="coming-soon">
  <img *ngIf="assetMap.icons.tv" [src]="assetMap.icons.tv" />
  <h1>{{ 'comingSoon.name' | translate }}</h1>
  <h2>{{ 'comingSoon.tagline' | translate }}</h2>
</div>
